<template>
  <AppLayout>
    <router-view />
  </AppLayout>
  <component v-for="c in $autoMountComponents" :key="c" :is="c" />
  <VBusHelper :emitOnMounted="$constants.EVENTS.APP.READY" />
</template>
